
import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "Profil",
    dangerZone: "Nevarno območje",
    deleteAccount: "Izbriši račun",
    confirmDelete: "Potrdi izbris",
    deleteWarning: "Ali ste prepričani, da želite izbrisati svoj račun? Ta ukrep je nepreklicen.",
    confirmDeleteButton: "Izbriši račun",
    accountDeleted: "Račun izbrisan",
    accountDeletedMessage: "Vaš račun je bil uspešno izbrisan."
  },
  common: {
    cancel: "Prekliči",
    delete: "Izbriši",
    deleteConfirmation: "Potrditev izbrisa",
    deleteConfirmationMessage: "Ali ste prepričani, da želite izbrisati"
  }
};
